import React, { useState, useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { signOutUser } from "../../store/actions/authActions";
import Loader from "../../components/style/Loader";
import SubscriptionComponent from "../../components/SubscriptionComponent";
import FreeTrialComponent from "../../components/FreeTrialComponent";
import Navbar from "../../components/layout/Navbar";

const Dashboard = (props) => {
  const [isUserExists, setIsUserExists] = useState(true);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [isSubscribeNowClicked, setIsSubscribeNowClicked] = useState(false);
  const [freeTrialData, setFreeTrialData] = useState({});
  const [subscriptionData, setSubscriptionData] = useState({});

  // Check if subscription is active or not
  useEffect(() => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/admin/subscription/check-active-subscription/${existingUser}`,
    })
      .then(({ data }) => {
        setIsPageLoaded(true);

        // 1. For Free Trial
        if (data.freeTrialData) {
          const {
            isFreeTrialEnded,
            daysLeftToFreeTrialEnding,
          } = data.freeTrialData;

          setFreeTrialData({
            isFreeTrialEnded,
            daysLeftToFreeTrialEnding,
          });
        }

        // 2. For Subscription
        if (data.subscriptionData) {
          const {
            isSubscriptionEnded,
            daysLeftToSubscriptionEnding,
          } = data.subscriptionData;
          setSubscriptionData({
            isSubscriptionEnded,
            daysLeftToSubscriptionEnding,
          });
        }
      })
      .catch((error) => {
        setIsUserExists(false);
      });
  }, []);

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const handlePaymentProcess = async (e) => {
    e.preventDefault();

    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Something went wrong. Please try later");
      return;
    }

    setIsSubscribeNowClicked(true);

    const API_URL = process.env.REACT_APP_API_URL;
    const orderUrl = `${API_URL}/admin/subscription/create-order`;
    const response = await axios.get(orderUrl);
    const { data } = response;

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      name: process.env.REACT_APP_ORGANIZATION_NAME,
      description: process.env.ORGANIZATION_DESCRIPTION,
      order_id: data.order.id,
      method: {
        netbanking: true,
        card: true,
        wallet: true,
        upi: true,
      },
      handler: async function (response) {
        const url = `${API_URL}/admin/subscription/add-payment`;
        setIsPageLoaded(false);

        await axios
          .post(url, {
            ...response,
            order_id: data.order.id,
            adminId: existingUser,
          })
          .then(() => {
            alert("Your payment is successful.");
            window.location.reload();
          })
          .catch((err) => {
            alert("Something went wrong. Please try again");
          });
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();

    // On Payment failed
    rzp1.on("payment.failed", (response) => {
      setIsSubscribeNowClicked(false);
      alert("Something went wrong. Please try again");
    });
  };

  // Handle Sign Out
  const handleSignOut = () => {
    signOutUser();
  };

  const { existingUser, signOutUser } = props;

  // If user data not exists
  if (existingUser === null) return <Redirect to="/login" />;

  // if user not exists
  if (!isUserExists) return <Redirect to="/404" />;

  return isPageLoaded ? (
    <>
      <Navbar />
      <main className="dashboard">
        {Object.keys(freeTrialData).length !== 0 ? (
          <FreeTrialComponent
            isFreeTrialEnded={freeTrialData.isFreeTrialEnded}
            daysLeftToFreeTrialEnding={freeTrialData.daysLeftToFreeTrialEnding}
            handlePaymentProcess={handlePaymentProcess}
            handleSignOut={handleSignOut}
            isSubscribeNowClicked={isSubscribeNowClicked}
          />
        ) : (
          <SubscriptionComponent
            isSubscriptionEnded={subscriptionData.isSubscriptionEnded}
            daysLeftToSubscriptionEnding={
              subscriptionData.daysLeftToSubscriptionEnding
            }
            handlePaymentProcess={handlePaymentProcess}
            handleSignOut={handleSignOut}
          />
        )}
      </main>
    </>
  ) : (
    <Loader />
  );
};

const mapStateToProps = () => {
  const existingUser = localStorage.getItem("adminId");

  return {
    existingUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOutUser: () => {
      dispatch(signOutUser());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
